import React from "react";
import { ArrowRight, FileText } from "lucide-react";
import { CATEGORIES } from "../data/site";

export default function ProductCategories() {
  return (
    <section id="products" data-testid="products-section" className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
          <div className="max-w-2xl">
            <div className="overline mb-4">Product Categories</div>
            <h2 className="section-heading text-navy text-3xl md:text-4xl lg:text-5xl font-bold">
              Authentic Indian brands across every FMCG shelf.
            </h2>
            <p className="mt-5 text-lg text-slate-600">
              From atta and snacks to personal care and stationery — sourced from
              authorized channels and consolidated into mixed containers.
            </p>
          </div>
          <a href="#contact" data-testid="request-catalogue" className="btn-emerald self-start lg:self-auto">
            <FileText className="w-4 h-4" /> Request Product Catalogue
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {CATEGORIES.map((c) => (
            <a
              key={c.id}
              href="#contact"
              data-testid={`category-card-${c.id}`}
              className="group relative rounded-2xl overflow-hidden aspect-[4/5] card-hover shadow-sm"
            >
              <img
                src={c.img}
                alt={c.title}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-105"
              />
              <div
                className="absolute inset-0"
                style={{
                  background:
                    "linear-gradient(180deg, rgba(11,29,58,0) 30%, rgba(11,29,58,0.55) 60%, rgba(11,29,58,0.92) 100%)",
                }}
              />
              <div className="absolute inset-x-0 bottom-0 p-6 text-white">
                <div className="text-[10px] tracking-[0.2em] uppercase text-gold font-semibold">
                  {c.brands.length} Brand{c.brands.length > 1 ? "s" : ""}
                </div>
                <div className="font-display text-2xl font-bold mt-1">{c.title}</div>
                <div className="mt-2 text-sm text-white/80 line-clamp-2">
                  {c.brands.join(" · ")}
                </div>
                <div className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-white opacity-90 group-hover:opacity-100 group-hover:gap-2.5 transition-all">
                  Enquire <ArrowRight className="w-4 h-4" />
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-10 p-6 rounded-2xl bg-[#F7F9FC] border border-slate-100 text-center">
          <p className="text-slate-600">
            Don't see the brand you need?{" "}
            <a href="#contact" data-testid="products-fallback-cta" className="text-emerald font-semibold hover:underline">
              Share your requirement — we source across major Indian FMCG brands.
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
